import { getClient } from "~/modules/wordpress";
import limiter from "~/modules/limiter";
import PageTransition from "~/components/motion/page-transition";

import Page from "~/components/templates/page";
import ContentContext from "~/context/content";
import Error from "~/pages/_error";

import frontpageData from "~/data/frontpage.json";
import { paths } from "~/modules/static-paths";
import { resourcePaths } from "~/modules/link-parser";

const listingPageSlugs = Object.keys(resourcePaths);

const PagePage = ({ data, error }) => {
    if (!data || error) return <Error />;

    return (
        <PageTransition>
            <ContentContext layout="page" type="page" data={data}>
                <Page page={data} />
            </ContentContext>
        </PageTransition>
    );
};

export async function getStaticPaths() {
    const allPagePaths = await paths.pages();
    // Filter out slugs that are listing-page base routes (those have their own index.js)
    const filtered = allPagePaths.filter(
        ({ params }) => !listingPageSlugs.includes(params.slug)
    );
    return { paths: filtered, fallback: false };
}

export async function getStaticProps({ params }) {
    let { slug } = params;

    // Resolve frontpage slug
    if (slug === "/" && frontpageData) slug = frontpageData.slug;
    if (!slug || slug === "/") slug = "ringdna-inside-sales-software";

    try {
        await limiter();
        const wp = getClient();
        const res = await wp.pages().slug(slug).embed();
        const page = res && res.length ? res[0] : null;
        if (!page) {
            console.log(`[404]: page, slug=${slug}`);
            return { props: { error: 404 } };
        }
        return { props: { data: page } };
    } catch (e) {
        console.log(`[${e.status || 500}]: page, slug=${slug}`);
        return { props: { error: e.status || 500 } };
    }
}

export default PagePage;
